// extracted by mini-css-extract-plugin
module.exports = {"container":"text-inline-image-section-wrapper_container__9PkdE","imageContainer":"text-inline-image-section-wrapper_imageContainer__Fn_0G"};